// src/constants/delhiConstants.js
export const GET_DELHI_RECORDS_REQUEST = 'GET_DELHI_RECORDS_REQUEST';
export const GET_DELHI_RECORDS_SUCCESS = 'GET_DELHI_RECORDS_SUCCESS';
export const GET_DELHI_RECORDS_FAIL = 'GET_DELHI_RECORDS_FAIL';
export const GET_DELHI_RECORDS_RESET = 'GET_DELHI_RECORDS_RESET';

export const CREATE_DELHI_RECORD_REQUEST = 'CREATE_DELHI_RECORD_REQUEST';
export const CREATE_DELHI_RECORD_SUCCESS = 'CREATE_DELHI_RECORD_SUCCESS';
export const CREATE_DELHI_RECORD_FAIL = 'CREATE_DELHI_RECORD_FAIL';
export const CREATE_DELHI_RECORD_RESET = 'CREATE_DELHI_RECORD_RESET';

export const UPDATE_DELHI_RECORD_REQUEST = 'UPDATE_DELHI_RECORD_REQUEST';
export const UPDATE_DELHI_RECORD_SUCCESS = 'UPDATE_DELHI_RECORD_SUCCESS';
export const UPDATE_DELHI_RECORD_FAIL = 'UPDATE_DELHI_RECORD_FAIL';
export const UPDATE_DELHI_RECORD_RESET = 'UPDATE_DELHI_RECORD_RESET';

export const DELETE_DELHI_RECORD_REQUEST = 'DELETE_DELHI_RECORD_REQUEST';
export const DELETE_DELHI_RECORD_SUCCESS = 'DELETE_DELHI_RECORD_SUCCESS';
export const DELETE_DELHI_RECORD_FAIL = 'DELETE_DELHI_RECORD_FAIL';
export const DELETE_DELHI_RECORD_RESET = 'DELETE_DELHI_RECORD_RESET';

export const BULK_DELETE_DELHI_RECORDS_REQUEST = 'BULK_DELETE_DELHI_RECORDS_REQUEST';
export const BULK_DELETE_DELHI_RECORDS_SUCCESS = 'BULK_DELETE_DELHI_RECORDS_SUCCESS';
export const BULK_DELETE_DELHI_RECORDS_FAIL = 'BULK_DELETE_DELHI_RECORDS_FAIL';
export const BULK_DELETE_DELHI_RECORDS_RESET = 'BULK_DELETE_DELHI_RECORDS_RESET';

export const IMPORT_DELHI_RECORDS_REQUEST = 'IMPORT_DELHI_RECORDS_REQUEST';
export const IMPORT_DELHI_RECORDS_SUCCESS = 'IMPORT_DELHI_RECORDS_SUCCESS';
export const IMPORT_DELHI_RECORDS_FAIL = 'IMPORT_DELHI_RECORDS_FAIL';
export const IMPORT_DELHI_RECORDS_RESET = 'IMPORT_DELHI_RECORDS_RESET';

export const EXPORT_DELHI_RECORDS_REQUEST = 'EXPORT_DELHI_RECORDS_REQUEST';
export const EXPORT_DELHI_RECORDS_SUCCESS = 'EXPORT_DELHI_RECORDS_SUCCESS';
export const EXPORT_DELHI_RECORDS_FAIL = 'EXPORT_DELHI_RECORDS_FAIL';
export const EXPORT_DELHI_RECORDS_RESET = 'EXPORT_DELHI_RECORDS_RESET';

// Cell update constants for inline editing
export const UPDATE_DELHI_CELL_REQUEST = 'UPDATE_DELHI_CELL_REQUEST';
export const UPDATE_DELHI_CELL_SUCCESS = 'UPDATE_DELHI_CELL_SUCCESS';
export const UPDATE_DELHI_CELL_FAIL = 'UPDATE_DELHI_CELL_FAIL';
export const UPDATE_DELHI_CELL_RESET = 'UPDATE_DELHI_CELL_RESET';

// task status update 
export const SYNC_TASK_STATUS_REQUEST = 'SYNC_TASK_STATUS_REQUEST';
export const SYNC_TASK_STATUS_SUCCESS = 'SYNC_TASK_STATUS_SUCCESS';
export const SYNC_TASK_STATUS_FAIL = 'SYNC_TASK_STATUS_FAIL';
export const SYNC_TASK_STATUS_RESET = 'SYNC_TASK_STATUS_RESET';


// get name of fos 
export const GET_FIELD_EXECUTIVES_REQUEST = 'GET_FIELD_EXECUTIVES_REQUEST';
export const GET_FIELD_EXECUTIVES_SUCCESS = 'GET_FIELD_EXECUTIVES_SUCCESS';
export const GET_FIELD_EXECUTIVES_FAIL = 'GET_FIELD_EXECUTIVES_FAIL';
export const GET_FIELD_EXECUTIVES_RESET = 'GET_FIELD_EXECUTIVES_RESET';